<template>
    <div class="contenedor_modal">
        <div class="contenedor_modal_cuerpo">
            <div class="contenedor_modal_cabecera">
                <b-button v-if="modulo == 'crear'" type="button" size="sm" variant="danger" @click="cerrar"><i
                        class="fas fa-times"></i></b-button>
                <b-button v-else type="button" size="sm" variant="danger" @click="set_modulo('crear')"><i
                        class="fas fa-times"></i></b-button>

            </div>

            <b-container fluid="">
                <Crear v-if="modulo == 'crear'" v-on:actualizar_modulo="set_modulo('editar')" />
                <Editar v-if="modulo == 'editar'" />
            </b-container>
        </div>
    </div>
</template>

<script>
    import Crear from './Crear.vue'
    import Editar from './Editar.vue'

    export default {
        name: 'Muestra',
        components: {
            Crear,
            Editar
        },
        data() {
            return {
                modulo: 'crear'
            }
        },
        methods: {
            cerrar() {
                this.$emit('salir')
            },
            set_modulo(modulo) {
                this.modulo = modulo
            }

        },

    }
</script>

<style></style>